module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00575.df64ae98.jpg";